import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { CutLinesComponent } from '../cut-lines.component';
import { CutLineMode } from '../../../../../models/enum/shared/cut-line-mode.enum';
import { GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER } from '../../../models/grid-column-gap';

@Component({
  selector: 'app-print-card-right-cut-lines',
  templateUrl: './print-card-right-cut-lines.component.html',
  styleUrls: ['./print-card-right-cut-lines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PrintCardRightCutLinesComponent extends CutLinesComponent {
  // eslint-disable-next-line no-restricted-syntax
  @HostBinding('style.justify-content') get alignItems() {
    switch (this.layoutInstructions?.cutLineMode) {
      case CutLineMode.HugPerimeter:
        return 'flex-end';
      case CutLineMode.HugContent:
        return 'flex-start';
      case CutLineMode.Extended:
        return 'stretch';
    }
    return null;
  }

  protected readonly GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER = GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER;
}
